<template>
  <section class="innerpages animate__animated animate__slideInRight">
     <div class="container ">
        <div class="row">
           <div class="col-md-12 listPage">
              <nav aria-label="breadcrumb">
                 <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a>{{mainLabel}} Report</a></li>
                    <li class="breadcrumb-item" v-if="mainLabel === 'Pipeline'"><a>{{ pipeLineBreadCrumb }}</a></li>
                  <template v-else>
                    <li class="breadcrumb-item" v-if="secondLabel"><a>{{secondLabel}}</a></li>
                    <li class="breadcrumb-item" v-if="subStatusLabel"><a>{{lastLabel}}</a></li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>{{lastLabel}}</li>
                    <li class="breadcrumb-item active" aria-current="page" v-if="subStatusLabel">{{subStatusLabel}}</li>
                  </template>
                 </ol>
              </nav>
              
              <div class="d-flex align-items-center" style="gap: 4px;">
                <!-- Search Input Field -->
                <div class="position-relative flex-grow-1">
                  <!-- Search Icon -->
                  <svg class="search-icon" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background:new 0 0 451 451;" xml:space="preserve">
                    <g>
                      <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                        s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                        C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                        s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z"/>
                    </g>
                  </svg>
                  <input type="text" placeholder="Search by name" class="search form-control pr-4 my-0"  v-model.trim="searchQuery"/>
                  <button v-if="searchQuery" @click="resetFilter" type="button" class="btn-clear">
                    <svg data-v-37888afc="" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path data-v-37888afc="" d="M4.40928 13.3344L3.66553 12.5906L7.75615 8.50002L3.66553 4.4094L4.40928 3.66565L8.4999 7.75627L12.5905 3.66565L13.3343 4.4094L9.24365 8.50002L13.3343 12.5906L12.5905 13.3344L8.4999 9.24377L4.40928 13.3344Z" fill="#373F44"></path></svg>
                  </button>
                </div>
                <!-- Apply Button -->
                <div class="px-0">
                  <button class="btn btn-outline btnFilter" @click="loadTabData">Apply</button>
                </div>
              </div>

                 <div class="card source-details" v-for="(item, key) in masterData" :key="`lead${key}`">
                   <router-link :to="{name: 'Lead', params: {uuid: item.uuid}}" class="lead-detail-link">
                     <div class="card-body">
                        <div class="row">
                           <div class="col-8">
                              <span class="info-title">{{item.client_name}}</span>
                              <span class="project-title">{{item.enquiry}}</span>
                           </div>
                           <div class="col-4 text-right pl-0">
                              <span class="label-Lead">{{item.source}}</span>
                              <span class="label-status">{{item.sub_source}}</span>
                              <span class="label-status">{{item.status}}</span>
                              <span class="label-status">{{item.sub_status}}</span>
                           </div>
                           <div class="col-12">
                              <span class="label-assign">Assigned to: <span class="d-text">{{item.assigned_to}}</span></span>
                              <span class="more d-block" style="font-size:14px">{{item.comment}}</span>
                              <span v-if="item.ncd" class="label-assign ncd">NCD: <span class="d-text">{{item.ncd}}</span></span>
                           </div>
                        </div>
                     </div>
                   </router-link>
                 </div>
                 <span style="font-size:12px;">Count: {{masterData.length}}</span>
           </div>
        </div>
     </div>
  </section>
</template>
<script>
import {DEFAULT_SOURCCE_ID} from '../main.js'
export default {
 data(){
   return {
     masterData: [],
     secondLabelProp: "",
     mainLabel: "",
     searchQuery: ''
   }
 },
 created(){
   this.loadTabData();
 },
 computed: {
   lastLabel(){
     return (this.masterData[0] || {}).status
   },
   subStatusLabel(){
     return (this.masterData[0] || {}).sub_status
   },
   secondLabel(){
     if(this.masterDataEl.hasOwnProperty(this.secondLabelProp)){
       return this.masterDataEl[this.secondLabelProp]
     }
   },
   masterDataEl(){
     return (this.masterData[0] || {})
   },
   pipeLineBreadCrumb(){
     return this.$route.query?.type || 'Total leads'
   }
 },
 updated(){
   this.executeMoreLink();
 },
 methods: {
   executeMoreLink(){
     var showChar = 41;  // How many characters are shown by default
     var ellipsestext = "...";
     var moretext = "More";
     var lesstext = "Less";
     $('.more').each(function() {
         var content = $(this).html();
         if(content.length > showChar) {
           var c = content.substr(0, showChar);
           var h = content.substr(showChar, content.length - showChar);
             var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink text-link w-500">' + moretext + '</a></span>';
             $(this).html(html);
         }
     });
     $(".morelink").click(function(){
       if($(this).hasClass("less")) {
           $(this).removeClass("less");
           $(this).html(moretext);
       } else {
           $(this).addClass("less");
           $(this).html(lesstext);
       }
       $(this).parent().prev().toggle();
       $(this).prev().toggle();
       return false;
     });
   },
   resetFilter() {
     this.searchQuery = ''
     this.loadTabData()
   },
   loadTabData(){
     let fullName =  this.searchQuery;
     let apiEndpoint = ""
     let {itemType, itemId, statusId, subStatusId, fromDate, toDate} = this.$route.params
     if(itemType === "source"){
       this.mainLabel = "Source"
       this.secondLabelProp = "source"
       apiEndpoint = `/source/${itemId}/status/${statusId}/leads`
       this.$store.dispatch('setActiveTitle', 'Source Report');
     }  else if(itemType === "subsource"){
       this.mainLabel = "Sub Source"
       this.secondLabelProp = "sub_source"
       apiEndpoint = `/sub_source/${itemId}/status/${statusId}/leads`
       this.$store.dispatch('setActiveTitle', 'Sub Source Report');
     }else if(itemType === "enquiry"){
       this.mainLabel = "Enquiry"
       this.secondLabelProp = "enquiry"
       apiEndpoint = `/projects/${itemId}/status/${statusId}/leads`
       this.$store.dispatch('setActiveTitle', 'Enquiry Wise Report');
     }else if(itemType === "user"){
       this.mainLabel = "Users"
       this.secondLabelProp = "assigned_to"
       apiEndpoint = `/users/${itemId}/status/${statusId}/leads`
       this.$store.dispatch('setActiveTitle', 'User Wise Report');
     }else if(itemType === "qualification"){
       this.mainLabel = "Qualification"
       this.secondLabelProp = "source"
       apiEndpoint = `/projects/${statusId}/enquiry_source/${itemId}/leads`
       this.$store.dispatch('setActiveTitle', 'Qualification Report');
     }else if(itemType === "pipeline"){
       this.mainLabel = "Pipeline"
       this.secondLabelProp = "pipeline"
       apiEndpoint = `/pipeline_leads`
       this.$store.dispatch('setActiveTitle', 'Pipeline Report');
     }else{
       this.$router.replace('/');
       return;
     }
     if (itemType === 'pipeline') {
     let { start_date,end_date,manager_ids,project_ids,city_ids,visited,hide_test,pipeline_leads,user_ids,user_id,history_updated_at_from,history_updated_at_upto} = this.$route.query
      let params = { 
          manager_id:manager_ids,
          pipeline_leads:pipeline_leads,
          hide_test:hide_test,
          visited:visited,
          project_ids: Array.isArray(project_ids) ? project_ids : project_ids ? [project_ids] : [],
          city_ids: Array.isArray(city_ids) ? city_ids : city_ids ? [city_ids] : [],
          start_date: start_date,
          end_date: end_date,
          user_ids:Array.isArray(user_ids) ? user_ids : user_ids ? [user_ids] : [],
          user_id:user_id,
          history_updated_at_from:history_updated_at_from,
          history_updated_at_upto:history_updated_at_upto
      }
        if (this.searchQuery) {
          params.full_name = this.searchQuery;
          params.is_advanced_search = true;
        }
       this.$axios.get(`${apiEndpoint}`, {
        params: {
          ...params
        }
      }).then(res => this.masterData = res.data)
       .catch(err => swal("Error", err.response.data.message, "error"));
     } else {
     let sourceIds = this.$store.getters.selectedSources.join(',')
     if (itemType === 'subsource' && !sourceIds) {
      sourceIds = DEFAULT_SOURCCE_ID
     }
     let projectIds = []
     if (itemType != 'enquiry') {
       projectIds = this.$store.getters.selectedProjectIds.join(',')
     }
     let executive = ''
     let substatus = []
     let status = []
     if (itemType === 'qualification') {
      status = this.$store.getters.status
      executive = this.$store.getters.executive || ''
      substatus = this.$store.getters.substatus
     }
     let managerId = this.$store.getters.selectedManager || ''
     let sub_status_id="";
     if(subStatusId)
     sub_status_id=subStatusId;
     let params = {
       start_date: fromDate,
       end_date: toDate,
       manager_id: managerId,
       source_ids: sourceIds,
       project_ids: projectIds,
       sub_status_id: sub_status_id,
       executive_type: executive,
     };
     if (substatus) {
      params['lead_sub_statuses'] = substatus
     }
     if (status) {
      params['lead_statuses'] = status
     }
     if (this.$route.query.lead_type) {
      params['lead_type'] = this.$route.query.lead_type
     }
     if (this.searchQuery) {
       params.full_name = this.searchQuery;
       params.is_advanced_search = true;
     }
     let searchDataUrl = new URLSearchParams(params).toString();
     this.$axios.get(`${apiEndpoint}?${searchDataUrl}`)
       .then(res => this.masterData = res.data)
       .catch(err => swal("Error", err.response.data.message, "error"));
     }
    }
 }
}
</script>
<style scoped>
.ncd{
 float: none;
 margin-top: 5px;
 margin-bottom: 0;
 display: block;
}
.lead-detail-link{
 text-decoration: none;
}

.btn-clear, .search-icon{
 position: absolute;
 top: 50%;
 right: 4px;
 transform: translateY(-50%);
 background-color: transparent;
 border: none;
 outline: none;
}

.search-icon{
 right: unset;
 left: 12px;
 width: 15px;
 height: 15px;
 opacity: 0.5;
}

.btnFilter{
 font-size: 12px;
 padding:12px;
 background-color: #F8E2D0;
 color: rgba(0, 0, 0, 0.5);
 font-weight: 500;
 background: #F2F2F2;
 box-shadow: 2px 3px 16px #F2F2F2;
 border: .25px solid #F2F2F2;
}
</style>